import React from 'react';
import { withAuth } from '@okta/okta-react';
import { withAlert } from 'react-alert';
import { CrudForm } from '@westernmilling/eu_react_shared';

export default withAuth(withAlert()(class VolumeMeasurementForm extends CrudForm {
  constructor(props) {
    super(props);
    this.state.item.active = this.state.item.active === undefined ? true : this.state.item.active;
  }

  formType = () => 'Volume Measurement';

  getCrudType = () => 'credit/volume_measurements';

  successAlertMsg = () => this.successMsg('Volume Measurement');

  modalBodyRows = () => (
    <div>
      { this.getTextFieldRow('name', 'Name') }
      { this.activeField() }
    </div>
  )
}));
